import useCurrentCompany from 'hooks/useCurrentCompany';
import useMe from 'hooks/useMe';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { MENU_ITEMS, MOBILE_ADMIN_ITEMS } from '../../MyAccount-constants';

const ContainerComponent = ({ children }) => {
  const { me } = useMe();
  const { company } = useCurrentCompany();

  const isLoading = !company;

  const isAdmin = me?.role !== 'company-staff';

  // TODO: Put this back in once other settings pages are ready
  const items = useMemo(
    () => [...MENU_ITEMS, ...(isAdmin ? MOBILE_ADMIN_ITEMS : [])],
    [isAdmin],
  );

  const Tag = isLoading ? 'div' : Link;

  return children({
    isLoading,
    items,
    Tag,
  });
};

ContainerComponent.displayName = 'Menu-container';

export default ContainerComponent;
